import * as types from './mutation-types'
import {RESET_PROJECTS} from "./mutation-types";

export default {
  [types.LOAD_PROJECTS](state, {data, query}) {
    const projects = Array.isArray(data.data) ? data.data : Object.values(data.data)
    if(state.projectsMeta.currentQuery !== query || state.projectsMeta.current_page === data.meta.current_page) {
      state.projects = projects
    } else {
      state.projects = state.projects.concat(projects)
    }
    state.projectsMeta.current_page = data.meta.current_page
    state.projectsMeta.last_page = data.meta.last_page
    state.projectsMeta.currentQuery = query
  },

  [types.RESET_PROJECTS](state) {
    state.projects = []
    state.projectsMeta = {}
    state.projectsMeta.current_page = 1
    state.projectsMeta.last_page = 1
    state.projectsMeta.currentQuery = ''
  },

  [types.LOAD_PROJECT_REPORTS](state, {data, query}) {
    const projects = Array.isArray(data.data) ? data.data : Object.values(data.data)
    if(state.projectReportsMeta.currentQuery !== query || state.projectReportsMeta.current_page === data.current_page) {
      state.projectReports = projects
    } else {
      state.projectReports = state.projectReports.concat(projects)
    }
    state.projectReportsMeta.current_page = data.current_page
    state.projectReportsMeta.last_page = data.last_page
    state.projectReportsMeta.currentQuery = query
  },

  [types.RESET_PROJECT_REPORTS](state) {
    state.projectReports = []
    state.projectReportsMeta = {}
    state.projectReportsMeta.current_page = 1
    state.projectReportsMeta.last_page = 1
    state.projectReportsMeta.currentQuery = ''
  },

  [types.ADD_PROJECTS](state, data) {
    state.projectsCollection = data.data
  },
  [types.CURRENT_PROJECT](state, data) {
    state.currentProject = data.data
  },
  [types.ADD_PROJECT_COMMENTS](state, {comments, id}) {
    state.projectComments = {...state.projectComments, [id]: comments}
  },

  [types.ADD_PROJECT_COMMENT](state, {comment, id}) {
    let c = state.projectComments[id] || []
    c.unshift(comment)
    state.projectComments = {...state.projectComments, [id]: c}
  },

  [types.REMOVE_PROJECT_COMMENT](state, {id, project}) {
    let c = state.projectComments[project] || []
    c = c.filter(cc => cc.id !== id)
    state.projectComments = {...state.projectComments, [project]: c}
  },

  [types.ADD_PROJECT_DIRECTORIES](state, {directories, id}) {
    state.projectDirectories = {...state.projectDirectories, [id]: directories}
  },

  [types.ADD_PROJECT_DIRECTORY](state, {directory, id}) {
    let dir = state.projectDirectories[id] || []
    dir.unshift(directory)
    state.projectDirectories = {...state.projectDirectories, [id]: dir}
  },
  [types.ADD_PROJECT_STATUS](state, data) {
    state.status = data
  },
  [types.LOAD_REPORT_STATUS](state, data) {
    state.report_status = data
  },
  [types.LOAD_PROJECT_STEP_TASKS](state, data) {
    state.step_tasks = data.data
  },
  [types.LOAD_CURRENT_PROJECT_LOGS](state, {data, query}) {

    const projectLogs = Array.isArray(data.data) ? data.data : Object.values(data.data)
    if(state.currentProjectLogsMeta.currentQuery !== query || state.currentProjectLogsMeta.current_page === data.meta.current_page) {
      state.currentProjectLogs = projectLogs
    } else {
      state.currentProjectLogs = state.currentProjectLogs.concat(projectLogs)
    }
    state.currentProjectLogsMeta.current_page = data.meta.current_page
    state.currentProjectLogsMeta.last_page = data.meta.last_page
    state.currentProjectLogsMeta.currentQuery = query

  },
  [types.ADD_BUDGET_TRANSACTION_TYPE](state, data) {
    state.transactionTypes = data
  },
  [types.LOAD_USER_PERFORM_CRITERIAS](state, data) {
    state.performCriterias = data
  },
  [types.LOAD_PROJECT_REACTION_ENUM](state, data) {
    state.projectReactionEnum = data
  },
  [types.LOAD_ESTATES](state, data) {
    state.estates = data.data
  },
  [types.LOAD_SHEET_SUMMARY](state, data) {
    state.sheetSummariesEnum = data
  },
  [types.LOAD_SUMMARIES](state, data) {
    state.summaries = data.summary_sheet
  },

  [types.OFFICE_TASK_ALERT_STATS](state, data) {
    state.projectsTaskAlertCount = parseInt(data.data)
  }
}

